module.exports = __webpack_public_path__ + "img/fail.f038b66b.png";